export default function Badge({ children, color = "#516BCC", variant = "filled", small = false }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center",
      padding: small ? "2px 6px" : "4px 12px",
      borderRadius: 20, fontSize: small ? 10 : 12, fontWeight: 500,
      background: variant === "filled" ? color + "14" : "transparent",
      color,
      border: variant === "outline" ? `1px solid ${color}25` : "none",
      whiteSpace: "nowrap",
    }}>
      {children}
    </span>
  );
}
